import {
  NgModule,
  ModuleWithProviders,
  Component,
  Renderer2,
  ElementRef,
  Output,
  Input,
  EventEmitter,
  ChangeDetectionStrategy,
  HostBinding,
  OnDestroy,
  Optional,
  OnChanges,
  AfterViewInit,
  SimpleChanges,
  ContentChildren,
  QueryList,
  forwardRef,
  Directive,
  ViewChild,
  ContentChild,
  HostListener,
  OnInit } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Subscriber } from 'rxjs/Subscriber';
import { Subject }         from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { LyRipple } from 'alyle-ui/ripple-minimal';
import { Observable } from 'rxjs/Observable';
import {
  LyTheme,
  themeProperty,
  Platform,
  IsBoolean,
  LyBg,
  LyColor
 } from 'alyle-ui/core';
import { LyIconButton } from 'alyle-ui/icon-button';
import { LyShadowService } from 'alyle-ui/shadow';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

// @Directive({ selector: '[ly-button][raised]' })
// export class LyButtonRaised {
//   private _raised = true;
//   constructor() { }
// }

@Component({
  selector: '[ly-button], ly-button',
  styles: [":host { z-index: 1; padding: 0; justify-content: center; -webkit-tap-highlight-color: transparent; line-height: 36px; white-space: nowrap; transform: scale3d(1, 1, 1); } @media not all and (hover: none) { :host:after { content: ''; top: 0; left: 0; right: 0; bottom: 0; position: absolute; background: currentColor; opacity: 0; border-radius: inherit; pointer-events: none; transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1); } :host:hover:after { opacity: .11; } } .ly-button-ripple { position: absolute; top: 0; bottom: 0; left: 0; right: 0; display: block; width: 100%; height: 100%; z-index: 2; transform: scale3d(1, 1, 1); border-radius: inherit; overflow: hidden; pointer-events: none; } .ly-button-hover { pointer-events: none; position: absolute; top: 0; bottom: 0; left: 0; right: 0; border-radius: inherit; opacity: 0; background: currentColor; transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1); } :host /deep/ [ly-icon-button] { z-index: 5 !important; } :host /deep/ [ly-icon-button] { color: currentColor !important; } .ly-button-content { text-align: inherit; height: 100%; justify-content: inherit; align-items: center; width: 100%; display: flex; position: relative; box-sizing: border-box; line-height: inherit; white-space: inherit; } .ly-button-padding { padding: 0 16px; } .ly-button-padding-left { padding-left: 16px; } .ly-button-padding-right { padding-right: 16px; } :host.ly-button-init { transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1) 0ms !important; } :host._disabled { pointer-events: none !important; background: rgba(0, 0, 0, 0.14) !important; color: rgba(0, 0, 0, 0.48) !important; box-shadow: none !important; } :host /deep/ [type=\"file\"] { position: absolute; top: 0; bottom: 0; left: 0; right: 0; opacity: 0; display: none; } :host:-moz-focusring::-moz-focus-inner { border-color: transparent; } :host { background: transparent; color: currentColor; border: none !important; -moz-appearance: none; min-height: 36px; height: 36px; margin: 0; border-radius: 4px; outline: none !important; font-size: 14px; font-weight: 500; min-width: 88px; box-sizing: border-box; position: relative; text-align: center; cursor: pointer; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; display: inline-block; transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; } /deep/ { /* button raised */ } /deep/ [ly-button~=\"disabled\"] { pointer-events: none; background: transparent; color: #000; opacity: .26; } /deep/ [ly-n], /deep/ [ly-w], /deep/ [ly-c] { overflow: hidden; } /deep/ [ly-c] { z-index: 4; border-radius: inherit; pointer-events: none; } /deep/ [ly-c] div { transition: all 0.7s ease-out; transition-property: opacity, -webkit-transform; transition-property: transform, opacity; transition-property: transform, opacity, -webkit-transform; /*-webkit-transform: scale(0); transform: scale(0);*/ pointer-events: none; position: relative; cursor: pointer; display: inline-block; overflow: hidden; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; -webkit-tap-highlight-color: transparent; will-change: opacity, transform; opacity: 1; box-sizing: border-box; } /deep/ [ly-n] { position: relative !important; padding: 0 16px; height: 100%; width: 100%; box-sizing: border-box; display: inline-flex; cursor: pointer; pointer-events: none; } /deep/ [ly-n], /deep/ [ly-w], /deep/ [ly-c], /deep/ [ly-c] { position: absolute; top: 0; bottom: 0; left: 0; right: 0; overflow: hidden; /*transition: cubic-bezier(0.25, 0.46, 0.45, 0.94) 975ms*/ } /deep/ [ly-button~=\"raised\"]:active { box-shadow: rgba(0, 0, 0, 0.12) 0px 3px 11px, rgba(0, 0, 0, 0.123) 0px 3px 11px !important; } /deep/ [ly-button~=\"raised\"]:focus { box-shadow: rgba(0, 0, 0, 0.12) 0px 3px 11px, rgba(0, 0, 0, 0.123) 0px 3px 11px !important; } /deep/ [ly-button~=\"raised\"]:not([ly-button~=\"disabled\"]) { box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 6px, rgba(0, 0, 0, 0.123) 0px 2px 4px; } :host /deep/ .btn_cont { display: block; line-height: inherit; height: inherit; align-content: space-around; text-align: center; align-self: center; alignment-baseline: middle; align-items: center; text-align: inherit; white-space: nowrap; width: inherit; text-overflow: ellipsis; overflow: hidden; } :host /deep/ [ly-w] { pointer-events: none; } :host /deep/ .rippleEffect { -webkit-transform: scale(0); -moz-transform: scale(0); transform: scale(0); -ms-transform: scale(0); -os-transform: scale(0); opacity: .18; } "],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '[class._disabled]': '_disabled',
    '[class.ly-button-init]': '_hasButton()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div class="ly-button-ripple" lyRipple [lyRippleSensitive]="rippleSensitive"></div>
  <div class="ly-button-content" [style.font-family]="(theme.typography | async)?.fontFamily" [ngClass]="buttonPadding | async">
    <ng-content></ng-content>
  </div>
  `,
  preserveWhitespaces: false
})
export class LyButton implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private _lastClass: string;
  public _disabled = false;
  public _prevFocused = true;
  private html: any = '';
  private styleRipple: any;
  private size = 10;
  private distancefromV: any;
  private stateH = true;
  private timePress: any;
  private _color = 'colorText';
  private _deep: any = false;
  private _bg = 'rgba(0, 0, 0, 0)';
  private e: any;
  private colorString: string = null;
  private bgString: string = null;
  _subscription: Subscription;
  private _raised: string | boolean = false;
  nativeElement: HTMLElement;
  private _rippleSensitive = false;
  @HostBinding('style.box-shadow') boxShadow: any;
  @Input('sensitive')
  get rippleSensitive(): boolean {
    return this._rippleSensitive;
  }
  set rippleSensitive(value: boolean) {
    if (value === false) {
      this._rippleSensitive = false;
    } else {
      this._rippleSensitive = true;
    }
  }

  @Input() color: string;
  @Input() bg: string;
  @Input() @IsBoolean() raised: boolean;
  @Input() @IsBoolean() raisedColorInverted: string;

  @HostBinding('style.background') styleBackground: string;
  @HostBinding('style.color') styleColor: string;
  @ViewChild(LyRipple) ripple: LyRipple;
  @ContentChildren(forwardRef(() => LyIconButton)) iconButton: QueryList<LyIconButton>;
  buttonPadding: Subject<string> = new BehaviorSubject<string>('');
  span = true;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private shadowService: LyShadowService,
    public theme: LyTheme,
    @Optional() private lyColor: LyColor,
    @Optional() private lyBg: LyBg
  ) {
    this.nativeElement = this.elementRef.nativeElement;
  }
  ngOnInit() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.raised || this.raisedColorInverted) {
      let colorRaised = this.bg || this.color || '';
      if (this.raisedColorInverted) {
        colorRaised = this.color;
      }
      this._lastClass = this.shadowService.setShadow(this.elementRef, this.renderer, ['3', colorRaised], this._lastClass);
    } else if (this._lastClass) {
      /** reset */
      this.renderer.removeClass(this.elementRef.nativeElement, this._lastClass);
      this._lastClass = null;
    }
  }
  ngOnDestroy() { }

  public focused() {
    this.elementRef.nativeElement.focus();
  }
  private get btnWidth() {
    return this.elementRef.nativeElement.offsetWidth;
  }
  ngAfterViewInit() {
    const el: HTMLElement = this.elementRef.nativeElement;
    if (Platform.isBrowser) {
      this.ripple.setTriggerElement(el);
      Promise.resolve(null).then(() => {
        if (this.iconButton.length !== 0) {
          let left: string;
          let right: string;
          this.iconButton.forEach((iconButton: LyIconButton) => {
            const ele = iconButton.elementRef.nativeElement as HTMLElement;
            let eve: any = ele;
            while (eve = eve.previousSibling) {
              if (eve.nodeName === '#text' && eve.nodeValue.trim() !== '') {
                left = 'ly-button-padding-left';
              }
            }
            eve = ele;
            while (eve = eve.nextSibling) {
              if (eve.nodeName === '#text' && eve.nodeValue.trim() !== '') {
                right = 'ly-button-padding-right';
              }
              // this.buttonPadding.next(`${right}`);
              // this.buttonPadding.next(`${right}`);
            }
          });
          setTimeout(() => {
            right === right && this.iconButton.length === 2 ? this.buttonPadding.next(``) : this.buttonPadding.next(`${right || ''} ${left || ''}`);
          });
        } else {
          this.buttonPadding.next('ly-button-padding');
        }
      });
    }

  }
  private get btnHeight() {
    return this.elementRef.nativeElement.offsetHeight;
  }
  @Input()
  public get deep(): any {
    return this._deep;
  }

  public set deep(val: any) {
    this._deep = val;
  }

  @Input()
  public get disabled(): boolean {
    return this._disabled;
  }

  public set disabled(val: boolean) {
    this._disabled = val;
    if (val) {
      this.elementRef.nativeElement.setAttribute('disabled', 'true');
    } else {
      this.elementRef.nativeElement.removeAttribute('disabled');
    }
  }
  public _hasButton() {
    return !!this.disabled || !!this.deep || !!this.bg  || !!this.color;
  }

  private sanitizerStyle(val: any): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(val);
  }
}
